export const getPusherChannel = (orgId: string): string => {
    const env = process.env.VERCEL_ENV ?? process.env.NEXT_PUBLIC_VERCEL_ENV

    if (env === "preview") {
        return `preview-${orgId}`
    }

    return orgId
}
